import React from 'react';
import './headerBottomStyles.scss';
import moment from 'moment';
import {useTranslation} from '../../hooks/useTranslation';

const HeaderBottom = ({inspection}) => {
  const {t} = useTranslation();
  return (
    <div className='inspection_detail_dates'>
      <div className='inspection_detail_dates__inspection_date'>
        <div>
          <p>{t('headerBottom.inspectionDate')}</p>
          <span>{moment(inspection?.date).format('MM/DD/YYYY')}</span>
        </div>
        <div>
          <p>{t('headerBottom.period')}</p>
          <span>{inspection?.period_label}</span>
        </div>
      </div>
      {inspection?.manual_inspection_date && (
        <div className='inspection_detail_dates__manual_inspection_date'>
          <div>
            <p>{t('headerBottom.manualInspectionDate')}</p>
            <span>
              {moment(inspection?.manual_inspection_date).format('MM/DD/YYYY')}
            </span>
          </div>
          <div>
            <p>{t('headerBottom.reason')}</p>
            <span>{inspection?.manual_inspection_date_description}</span>
          </div>
        </div>
      )}
      {inspection?.old_inspection_date && (
        <div className='inspection_detail_dates__manual_inspection_date'>
          <div>
            <p>{t('headerBottom.oldInspectionDate')}</p>
            <span>
              {moment(inspection?.old_inspection_date).format('MM/DD/YYYY')}
            </span>
          </div>
          <div>
            <p>{t('headerBottom.reason')}</p>
            <span>{inspection?.manual_inspection_date_description}</span>
          </div>
        </div>
      )}
    </div>
  );
};

export default HeaderBottom;
